<script setup lang="ts">
import { StrapiBlocks } from "vue-strapi-blocks-renderer";

useHead({
  title: "About Me",
});
const aboutMeData = useState<AboutMeData>("about-me-data");
const sliderData = useState<SliderData>("slider-data");
</script>
<template>
  <div class="content">
    <Breadcumb :title="'About Me'" :subtitle="'Get to know me better.'" :items="[{ text: 'Home', href: '/' }]" :to="{ text: 'About Me', href: '/about-me' }" />
    <!-- Block text section start  -->
    <div class="about-standard-row xboot-standard-row gray-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="adfas">
              <div class="about-me-text text-left">
                <div class="section-title-2">
                  <h2 class="area-title">{{ aboutMeData?.displayName }}</h2>
                  <p class="area-subtitle">{{ aboutMeData?.title }}</p>
                </div>
                <StrapiBlocks :content="aboutMeData?.description || []" />
                <div class="about-block-icons" >
                  <div class="single-block-option">
                    <i class="ti-vector"></i>
                    <p>{{ sliderData?.slides[0]?.words[0]?.text }}</p>
                  </div>
                  <div class="single-block-option">
                    <i class="ti-heart"></i>
                    <p>{{ sliderData?.slides[0]?.words[1]?.text }}</p>
                  </div>
                 <!-- <div class="single-block-option">
                    <i class="ti-bolt-alt"></i>
                    <p>{{ sliderData?.slides[0]?.words[2]?.text }}</p>
                  </div>-->
                </div>
                <NuxtLink to="/contact" class="button-boxed">Contact Me <i class="ti-arrow-right"></i></NuxtLink>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-me-img text-right">
              <img :src="composeImageUrl(aboutMeData?.image.url!)" :alt="`${aboutMeData?.displayName} Portrait`" />
            </div>
            <YouTubePlayer v-if="aboutMeData?.video" :url="aboutMeData?.video.youtube" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.about-me-img img {
  width: 100%;
  object-fit: contain;
}
.area-title{
  color: var(--primary-color);
}
.area-subtitle{
  color: var(--subtitle-color);
}
</style>
